import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_MARKETPLACE_API_URI,
  headers: {
    'Accept': 'application/json',
    'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
})

export default instance
